module.exports = __webpack_public_path__ + "img/wifi.59ac817d.svg";